import InforLayout from "../../layout/infor"

const inforRoutes = [{
		path: "/index*",
		name: "index",
		meta: {
			module: "home",
		},
		component: () => import("@/views/home")
	},
	{
		path: "/home",
		name: "home",
		meta: {
			module: "home",
		},
		component: () => import("@/views/home")
	},
	{
		path: "/shop/shoplist",
		name: "shoplist",
		meta: {
			module: "shop",
		},
		component: () => import("@/views/shop/shoplist")
	},
	{
		path: "/goods/goodslist",
		name: "goodslist",
		meta: {
			module: "goods",
		},
		component: () => import("@/views/goods/goodslist")
	},
	{
		path: "/information/details",
		name: "details",
		meta: {
			module: "information",
		},
		component: () => import("@/views/information/details")
	},
	{
		path: "/information/list",
		name: "list",
		meta: {
			module: "information",
		},
		component: () => import("@/views/information/list")
	},
	{
		path: "/information/hyzx",
		name: "hyzx",
		meta: {
			module: "hyzx",
		},
		component: () => import("@/views/information/hyzx")
	},
	{
		path: "/information/zhanhui",
		name: "zhanhui",
		meta: {
			module: "zhxx",
		},
		component: () => import("@/views/information/zhanhui")
	},
	{
		path: "/agricultural/index",
		name: "index",
		meta: {
			module: "agricultural",
		},
		component: () => import("@/views/agricultural/index")
	},
	{
		path: "/agricultural/expertlist",
		name: "expertlist",
		meta: {
			module: "agricultural",
		},
		component: () => import("@/views/agricultural/expertlist")
	},
	{
		path: "/agricultural/expertdetails",
		name: "expertdetails",
		meta: {
			module: "agricultural",
		},
		component: () => import("@/views/agricultural/expertdetails")
	},
	{
		path: "/agricultural/questionlist",
		name: "questionlist",
		meta: {
			module: "agricultural",
		},
		component: () => import("@/views/agricultural/questionlist")
	},
	{
		path: "/agricultural/questiondetails",
		name: "questiondetails",
		meta: {
			module: "agricultural",
		},
		component: () => import("@/views/agricultural/questiondetails")
	},
	{
		path: "/agricultural/courselist",
		name: "courselist",
		meta: {
			module: "agricultural",
		},
		component: () => import("@/views/agricultural/courselist")
	},
	{
		path: "/agricultural/coursedetails",
		name: "coursedetails",
		meta: {
			module: "agricultural",
		},
		component: () => import("@/views/agricultural/coursedetails")
	},
	{
		path: "/purchase/list",
		name: "list",
		meta: {
			module: "purchase",
		},
		component: () => import("@/views/purchase/list")
	},
	{
		path: "/purchase/details",
		name: "details",
		meta: {
			module: "purchase",
		},
		component: () => import("@/views/purchase/details")
	},
	{
		path: "/supply/list",
		name: "list",
		meta: {
			module: "supply",
		},
		component: () => import("@/views/supply/list")
	},
	{
		path: "/supply/details",
		name: "details",
		meta: {
			module: "supply",
		},
		component: () => import("@/views/supply/details")
	},
	{
		path: "/pricequotes/list",
		name: "list",
		meta: {
			module: "pricequotes",
		},
		component: () => import("@/views/pricequotes/list")
	},
	{
		path: "/zhihui/zhihui",
		name: "zhihui",
		meta: {
			module: "zhihui",
		},
		component: () => import("@/views/zhihui/zhihui")
	},
	{
		path: "/zhihui/iot",
		name: "iot",
		meta: {
			module: "zhihui",
		},
		component: () => import("@/views/zhihui/iot")
	},
	{
		path: "/zhihui/tongyong",
		name: "tongyong",
		meta: {
			module: "zhihui",
		},
		component: () => import("@/views/zhihui/tongyong")
	},
	{
		path: "/zhihui/zhstjjfa",
		name: "zhstjjfa",
		meta: {
			module: "zhihui",
		},
		component: () => import("@/views/zhihui/zhstjjfa")
	},
	{
		path: "/zhihui/ts",
		name: "ts",
		meta: {
			module: "zhihui",
		},
		component: () => import("@/views/zhihui/ts")
	},
	{
		path: "/zhihui/nongzheng",
		name: "nongzheng",
		meta: {
			module: "zhihui",
		},
		component: () => import("@/views/zhihui/nongzheng")
	},
	{
		path: "/zhihui/zhongzhi",
		name: "zhongzhi",
		meta: {
			module: "zhihui",
		},
		component: () => import("@/views/zhihui/zhongzhi")
	},
	{
		path: "/zhihui/zhifa",
		name: "zhifa",
		meta: {
			module: "zhihui",
		},
		component: () => import("@/views/zhihui/zhifa")
	},
	{
		path: "/zhihui/nongzi",
		name: "nongzi",
		meta: {
			module: "zhihui",
		},
		component: () => import("@/views/zhihui/nongzi")
	},
	{
		path: "/zhihui/guihua",
		name: "guihua",
		meta: {
			module: "zhihui",
		},
		component: () => import("@/views/zhihui/guihua")
	},
]


export default {
	path: "/",
	component: InforLayout,
	redirect: "/home",
	name: "home",
	children: [
		...inforRoutes,
	]
}
